module.exports = __webpack_public_path__ + "75ec533ab81d8c9c9439b923e6804fe8.svg";